<div class="loading" *ngIf="loading"></div>
<div
    class="modal-header d-flex flex-column align-items-center justify-content-center border-0 pb-3 position-relative redesigned-header">
    <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"
        (click)="dismiss()">
    </button>
    <div class="avatar mb-2 mt-2">
        <div class="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
            style="width: 80px; height: 80px; background: linear-gradient(135deg, #FF9933 0%, #FF512F 100%);">
            <i class="bi bi-person-fill text-white" style="font-size: 3.5rem;"></i>
        </div>
    </div>
    <h4 class="login-title divine-font fw-bold m-0 mt-2">{{TOGGLE_ACTIONS[activeAction]?.title || 'Login / Sign Up'}}
    </h4>
</div>
<div class="modal-body pt-0">
    <!-- Quick Biometric / PIN Unlock for Enrolled Device -->
    <div *ngIf="hasEnrolledBiometrics && (activeAction === 'LOGIN' || activeAction === 'OTP')"
        class="biometric-unlock-card mb-3 p-3 rounded-4 border bg-light shadow-sm">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="d-flex align-items-center">
                <div class="rounded-circle d-flex align-items-center justify-content-center me-2"
                    style="width: 40px; height: 40px; background: linear-gradient(135deg, #FF9933, #FF512F); color: #fff;">
                    <i class="bi bi-shield-lock-fill fs-5"></i>
                </div>
                <div style="line-height: 1.2;">
                    <div class="fw-bold text-dark text-truncate" style="max-width: 170px;">
                        {{ enrolledUser?.name || enrolledUser?.firstName || 'Devotee' }}
                    </div>
                    <small class="text-success" style="font-size: 0.75rem;">
                        <i class="bi bi-patch-check-fill me-1"></i>Biometrics / PIN Enrolled
                    </small>
                </div>
            </div>
            <button type="button" class="btn btn-link btn-sm text-decoration-none text-muted p-0"
                style="font-size: 0.75rem;" (click)="hasEnrolledBiometrics = false">
                Switch User
            </button>
        </div>

        <button type="button"
            class="btn btn-warning w-100 fw-bold py-2 shadow-sm d-flex align-items-center justify-content-center text-dark"
            (click)="unlockWithBiometrics()" [disabled]="biometricLoading">
            <span *ngIf="biometricLoading" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!biometricLoading" class="bi bi-fingerprint me-2 fs-5"></i>
            Sign In with Windows Hello / Fingerprint
        </button>

        <div *ngIf="biometricPromptError" class="alert alert-danger py-1 px-2 mt-2 mb-0 small text-center">
            <i class="bi bi-exclamation-triangle-fill me-1"></i> {{ biometricPromptError }}
        </div>

        <div class="position-relative my-3 text-center">
            <hr class="m-0" />
            <span class="position-absolute top-50 start-50 translate-middle bg-light px-2 small text-muted">
                or continue with
            </span>
        </div>
    </div>

    <ng-container [ngSwitch]="activeAction">
        <ng-container *ngSwitchCase="'EMAIL_VERIFICATION'">
            <app-email-verification (skip)="emailSkip()"
                (provider)="signInWithSocial($event)"></app-email-verification>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <app-login-form [isAfterSocioLogin]="activeAction === 'MOBILE_OTP' || !!currentUser"
                [mobileNumber]="mobileNumber" (socialLogin)="signInWithSocial($event)"
                (openTerms)="openTermsModal()" (openPrivacy)="openPrivacyModal()">
            </app-login-form>
        </ng-container>
    </ng-container>
</div>